import * as React from "react";

import "./Select.style.scss";

interface SelectProps {
  items: { [k: string]: string };
  selected?: string;
  cb: (e: React.SyntheticEvent) => void;
}

export const Select = ({ items, selected, cb }: SelectProps) => (
  <select onChange={cb} onBlur={cb} className="component-select" value={selected}>
    {Object.keys(items).map((key, i) => (
      <option key={i} value={key}>
        {items[key]}
      </option>
    ))}
  </select>
);

export default Select;
